/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeWhiteMenuItemExpandableItemText } from "./d-theme-white-menu-item-expandable-item-text";

export class DThemeWhiteMenuSidedItemExpandableItemText extends DThemeWhiteMenuItemExpandableItemText {}
